import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Typography, Modal, Button } from "antd";

const { Text, Paragraph } = Typography;

const Producer = ({ data }) => {
  const { t } = useTranslation();
  const [showProducerModal, setShowProducerModal] = useState(false);

  return (
    <>
      <small>
        <Text className="producer-name">
          <strong>{t("support.producerLabel")}</strong>{" "}
          <span onClick={() => setShowProducerModal(true)} className="clickable_hover">
            {data?.name}
          </span>
        </Text>
      </small>

      <Modal
        visible={showProducerModal}
        title={t("support.contactProducer")}
        onCancel={() => setShowProducerModal(false)}
        footer={[
          <Button key="back" onClick={() => setShowProducerModal(false)}>
            {t("support.close")}
          </Button>,
        ]}
      >
        <strong>{t("support.name")}: </strong>
        <Paragraph level={5}>{data?.name}</Paragraph>
        <strong>{t("support.emailFullLabel")} </strong>
        <Paragraph level={5} copyable={{ tooltips: [t("support.copy"), t("support.copied")] }}>
          {data?.email}
        </Paragraph>
      </Modal>
    </>
  );
};

export default Producer;
